import * as Extent from 'ol/extent';
import transformCoords from '../../../shared/utils/transformCoords';

export const calculateHistoryExtent = (coords) => {
  if (!coords?.length) return undefined;

  const ext = Extent.boundingExtent(coords.map((c) => transformCoords(c.longitude, c.latitude)));
  return ext;
};

export const getExtentCoordsAroundPoint = (source) => {
  if (!source?.length) return [];

  const last = source[source.length - 1];
  const padding = 100000;

  // Возвращаем несколько точек вокруг последней, чтобы корректно получить extent
  return [
    { ...last, longitude: last.longitude - padding, latitude: last.latitude - padding },
    last,
    { ...last, longitude: last.longitude + padding, latitude: last.latitude + padding },
  ];
};
